import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormComponent } from './components/form/form.component';
import { QuestionComponent } from './components/question/question.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ListComponent } from './components/list/list.component';
import { ChipSuccessComponent } from './components/chip-success/chip-success.component';
import { CustomAnswerRadioComponent } from './components/custom-answer-radio/custom-answer-radio.component';
import { SliderComponent } from './components/slider/slider.component';
import { CheckboxSetComponent } from './components/checkbox-set/checkbox-set.component';
import { MultiTextboxComponent } from './components/multi-textbox/multi-textbox.component';
import { InfoBoxComponent } from './components/info-box/info-box.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { AddressboxComponent } from './components/addressbox/addressbox.component';
import { TuvLogoComponent } from './components/tuv-logo/tuv-logo.component';
import { JumbotronComponent } from './components/jumbotron/jumbotron.component';
import { SnackbarDirective } from './directives/snackbar.directive';
import { ImagePlaceholderDirective } from './directives/image-placeholder.directive';
import { JoinPipe } from './pipes/join.pipe';
import { EnergySourceToIconPipe } from './pipes/energy-source-to-icon.pipe';
import { AsPipe } from './pipes/as.pipe';
import { FormFieldStylesPipe } from './pipes/form-field-styles.pipe';
import { IsNilPipe } from './pipes/is-nil.pipe';
import { CountryCodePipe } from './pipes/country-code.pipe';
import { LanguageCodePipe } from './pipes/language-code.pipe';
import { PrefixPipe } from './pipes/prefix.pipe';
import { TotalHeatloadPipe } from './pipes/total-heatload.pipe';
import { MaterialModule } from './material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';
import { ActiveAnchorDirective } from './directives/active-anchor.directive';
import { DisableOnPipe } from './pipes/disable-on.pipe';
import { IsOfCountryPipe } from './pipes/is-of-country.pipe';
import { ProjectStatusStylesPipe } from './pipes/project-status-styles.pipe';
import { CompanyTileComponent } from './components/company-tile/company-tile.component';
import { ViewHostDirective } from './directives/view-host.directive';
import { SearchDropdownComponent } from './components/search-dropdown/search-dropdown.component';
import { GtmEventDirective } from './directives/gtm-event.directive';
import { GegAllowSubsidyCalculatorLinkPipe } from './pipes/geg-allow-subsidy-calculator-link.pipe';
import { GegRecommendationIconPipe } from './pipes/geg-recommendation-icon.pipe';
import { GegRecommendationTypePipe } from './pipes/geg-recommendation-type.pipe';
import { WidthTooltipDirective } from './directives/width-tooltip.directive';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { IsReadOnlyPipe } from './pipes/is-read-only.pipe';
import { IsOfStatusPipe } from './pipes/is-of-status.pipe';
import { HasPartnerPipe } from './pipes/has-partner.pipe';
import { OrderStatusStylesPipe } from './pipes/order-status-styles.pipe';
import { OrderStatusDictionaryPipe } from './pipes/order-status-dictionary.pipe';
import { FilterBySystemTypePipe } from './pipes/filter-by-system-type.pipe';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { StatusPageComponent } from './components/status-page/status-page.component';
import { RadioComponent } from './components/radio/radio.component';
import { TextboxComponent } from './components/textbox/textbox.component';
import { AdvancedSearchComponent } from './components/advanced-search/advanced-search.component';
import { MultiQuestionboxComponent } from './components/multi-questionbox/multi-questionbox.component';
import { CustomShortDatePipe } from './pipes/custom-short-date.pipe';
import { TranslateKeysPipe } from './pipes/translate-keys.pipe';
import { TranslateArrayPipe } from './pipes/translate-array.pipe';
import { TranslateArrayKeysPipe } from './pipes/translate-array-keys.pipe';

const COMPONENTS = [
    FormComponent,
    QuestionComponent,
    NavbarComponent,
    ListComponent,
    ChipSuccessComponent,
    CustomAnswerRadioComponent,
    SliderComponent,
    CheckboxSetComponent,
    CheckboxComponent,
    MultiTextboxComponent,
    InfoBoxComponent,
    DropdownComponent,
    AddressboxComponent,
    TuvLogoComponent,
    JumbotronComponent,
    CompanyTileComponent,
    SearchDropdownComponent,
    PaginatorComponent,
    StatusPageComponent,
    RadioComponent,
    TextboxComponent,
    AdvancedSearchComponent,
    MultiQuestionboxComponent
];
const DIRECTIVES = [
    WidthTooltipDirective,
    SnackbarDirective,
    SnackbarDirective,
    ImagePlaceholderDirective,
    ActiveAnchorDirective,
    ViewHostDirective,
    GtmEventDirective
];
const PIPES = [
    JoinPipe,
    EnergySourceToIconPipe,
    AsPipe,
    FormFieldStylesPipe,
    IsNilPipe,
    CountryCodePipe,
    LanguageCodePipe,
    PrefixPipe,
    TotalHeatloadPipe,
    DisableOnPipe,
    IsOfCountryPipe,
    ProjectStatusStylesPipe,
    OrderStatusStylesPipe,
    OrderStatusDictionaryPipe,
    GegAllowSubsidyCalculatorLinkPipe,
    GegRecommendationIconPipe,
    GegRecommendationTypePipe,
    IsReadOnlyPipe,
    IsOfStatusPipe,
    HasPartnerPipe,
    FilterBySystemTypePipe,
    CustomShortDatePipe,
    TranslateKeysPipe,
    TranslateArrayPipe,
    TranslateArrayKeysPipe
];

@NgModule({
    declarations: [...COMPONENTS, ...DIRECTIVES, ...PIPES],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        RouterModule,
        NgxMaskDirective,
        NgxMaskPipe,
        TranslateModule,
        ComponentsModule
    ],
    exports: [
        NgxMaskDirective,
        NgxMaskPipe,
        TranslateModule,
        ComponentsModule,
        MaterialModule,
        ReactiveFormsModule,
        ...COMPONENTS,
        ...DIRECTIVES,
        ...PIPES
    ],
    providers: [provideEnvironmentNgxMask()]
})
export class SharedUiModule {}
